import { render, staticRenderFns } from "./ProfileSubscribePaymentChoose.vue?vue&type=template&id=ec22a332&"
import script from "./ProfileSubscribePaymentChoose.vue?vue&type=script&lang=ts&"
export * from "./ProfileSubscribePaymentChoose.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSubscribePaymentChoose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports